export default __webpack_public_path__ + "strongher-screens_small@2x.fc8a2d61.png";